var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.092,
    height: 20.123,
    viewBox: "0 0 15.092 20.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#3a4982;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-480.908 -690.877)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.172.536h5.68c1.885,1.885,3.761,3.524,5.787,5.55V16.951c0,1.657-.734,2.668-2.391,2.668h-9c-1.657,0-2.862-.868-2.862-2.525v-14A2.476,2.476,0,0,1,3.172.536Z",
    transform: "translate(481 691)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(478.908 690.877)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.629,7a.629.629,0,1,0,0,1.258h6.288a.629.629,0,1,0,0-1.258ZM5,10.144a.629.629,0,0,1,.629-.629h6.288a.629.629,0,1,1,0,1.258H5.629A.629.629,0,0,1,5,10.144Zm0,2.515a.629.629,0,0,1,.629-.629H8.144a.629.629,0,0,1,0,1.258H5.629A.629.629,0,0,1,5,12.659Z",
    transform: "translate(0.773 1.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.432,0H4.515A2.515,2.515,0,0,0,2,2.515V17.607a2.515,2.515,0,0,0,2.515,2.515H14.577a2.515,2.515,0,0,0,2.515-2.515V5.659Zm0,1.258V3.773a1.886,1.886,0,0,0,1.886,1.886h2.515V17.607a1.258,1.258,0,0,1-1.258,1.258H4.515a1.258,1.258,0,0,1-1.258-1.258V2.515A1.258,1.258,0,0,1,4.515,1.258Z",
    transform: "translate(0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.f7dffd2f67aff2192763f2cf9880a056.svg";
export { ForwardRef as ReactComponent };